const messages = {
  save: 'Save new address',
};

export default messages;
